
import LoggingService from "./logging-service";
import ILoggingService from "./logging-service-interface";

export interface LogFn { (message?: any, ...optionalParams: any[]): void; }
export interface ILogger { log: LogFn; error: LogFn; }

export class DatabaseLogger implements ILogger {
    readonly log: LogFn;
    readonly error: LogFn;
    readonly loggingService: ILoggingService;

    constructor() {
        this.loggingService = new LoggingService();
        this.log = this.createLogFn("info");
        this.error = this.createLogFn("error");
    }

    private createLogFn(level: "info" | "error"): LogFn {
        return (message?: any, ...optionalParams: any[]) => {
            const stackTrace = optionalParams
                .map(p => (typeof p === "object" ? JSON.stringify(p) : String(p)))
                .join(" | ");

            // Start the network request but don't wait for it
            (async () => {
                try {
                    if (level === "error") {
                        await this.loggingService.logError(message, stackTrace);
                    } else {
                        await this.loggingService.logInfo(message, stackTrace);
                    }
                } catch (err) {
                    console.error("Failed to log to database:", err);
                    console[level](message);
                }
            })();
        };
    }
}
